import { render, staticRenderFns } from "./UserPaidTab.vue?vue&type=template&id=888a9c36&"
import script from "./UserPaidTab.vue?vue&type=script&lang=js&"
export * from "./UserPaidTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSkeletonLoader,VTabItem})
